import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Loader from "../components/loader/Loader";
import ReturnReviewBooking from "../components/Return/ReturnReviewBooking"
import { get_fare_quote_resultindex, get_fare_rule_resultindex, showAlertMessage } from "../components/server/api";
import { setFareQuote, setFareRule } from "../redux/global/global.action";
import DefaultTemplate from "./DefaultTemplate"


const FlDetails = (props) => {
    const [loadcircle,setLoadCircle] = useState(0);
    const dispatch = useDispatch();

    
    const parameter = useParams();
    const get_flight_details = (data) => {
        setLoadCircle(1)
        get_fare_rule_resultindex(data).then((res)=>{
            if(res.status){
                dispatch(setFareRule({
                    ...res
                }))
            }else{
                showAlertMessage('oops',res.message,false,true)
                return
            }
            get_fare_quote_resultindex(data).then((rs)=>{
            setLoadCircle(0)

                if(rs.status){
                    dispatch(setFareQuote({
                        ...rs
                    }))
                }
            })
        })
    }
    useEffect(() => {
        get_flight_details(parameter)
    }, [])

    return (
        <DefaultTemplate>
            {
                loadcircle ? <Loader />
                : <ReturnReviewBooking />
            }
            
            
        </DefaultTemplate>
    )
}

export default FlDetails